var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCalendarDateIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V6",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V6",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9H21",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 4H5C3.895 4 3 4.895 3 6V19C3 20.105 3.895 21 5 21H19C20.105 21 21 20.105 21 19V6C21 4.895 20.105 4 19 4Z",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01463 12.7285C6.87663 12.7285 6.76463 12.8405 6.76563 12.9785C6.76563 13.1165 6.87763 13.2285 7.01563 13.2285C7.15363 13.2285 7.26563 13.1165 7.26563 12.9785C7.26563 12.8405 7.15363 12.7285 7.01463 12.7285",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0146 12.7285C11.8766 12.7285 11.7646 12.8405 11.7656 12.9785C11.7656 13.1165 11.8776 13.2285 12.0156 13.2285C12.1536 13.2285 12.2656 13.1165 12.2656 12.9785C12.2656 12.8405 12.1536 12.7285 12.0146 12.7285",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0146 12.7285C16.8766 12.7285 16.7646 12.8405 16.7656 12.9785C16.7656 13.1165 16.8776 13.2285 17.0156 13.2285C17.1536 13.2285 17.2656 13.1165 17.2656 12.9785C17.2656 12.8405 17.1536 12.7285 17.0146 12.7285",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01463 16.7285C6.87663 16.7285 6.76463 16.8405 6.76563 16.9785C6.76563 17.1165 6.87763 17.2285 7.01563 17.2285C7.15363 17.2285 7.26563 17.1165 7.26563 16.9785C7.26563 16.8405 7.15363 16.7285 7.01463 16.7285",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0146 16.7285C11.8766 16.7285 11.7646 16.8405 11.7656 16.9785C11.7656 17.1165 11.8776 17.2285 12.0156 17.2285C12.1536 17.2285 12.2656 17.1165 12.2656 16.9785C12.2656 16.8405 12.1536 16.7285 12.0146 16.7285",
    stroke: "#3378F9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCalendarDateIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/CalendarDateIcon.96b927e1.svg";
export { ForwardRef as ReactComponent };